module.exports = __webpack_public_path__ + "img/cp3-1.55903475.jpg";